<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <h3>{{$route.name}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <router-link to="/platform-user/audit-log">
        <el-button type="primary" style='position: absolute;right:10px;top:5px;'>
          <i class="el-icon-s-order"> 审计日志</i>
        </el-button>
      </router-link>
    </div>

    <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '新增后台用户'})">添加后台用户
      </el-button>
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '部门管理'})">部门管理
      </el-button>
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '权限组管理'})">权限组管理
      </el-button>
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '后台用户角色管理'})">角色管理
      </el-button>
    </layout-panel>


    <layout-panel :collapse="true">
      <span slot="header">搜索</span>

      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="用户名称："
                          prop="name">
              <el-input v-model="search.name"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="部门："
                          prop="department_id">
              <el-select v-model="search.department_id"
                         clearable>
                <el-option v-for="item in options.departments"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="状态："
                          prop="status">
              <el-select v-model="search.status"
                         clearable>
                <el-option v-for="item in options.status"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="角色："
                          prop="roles">
              <el-select v-model="search.roles"
                         multiple
                         clearable>
                <el-option v-for="item in options.roles"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注："
                          prop="desc">
              <el-input v-model="search.desc"
                        clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>

          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '批量分配客户'})">批量分配客户
      </el-button>
      <el-button type="primary"
                 size="mini"
                 v-for="permission in platformlist"
                 :key="permission.name"
                 @click="$router.push({name: '批量分配权限角色', params: {type: permission.name}})">批量分配{{permission.name}}角色
      </el-button>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="id"
                         label="序号"></el-table-column>

        <el-table-column prop="name"
                         label="用户名"></el-table-column>

        <el-table-column prop="phone"
                         label="手机号"></el-table-column>
        <el-table-column prop="mail_address"
                         label="邮箱"></el-table-column>
        <el-table-column prop="usertype"
                         label="类型">
          <template slot-scope="scope">
            <span>{{maps.type[scope.row.usertype] || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <span>{{maps.status[scope.row.status] || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="department_id"
                         label="部门">
          <template slot-scope="scope">
            <span>{{maps.department[scope.row.department_id] || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="created_at"
                         label="创建时间">
          <template slot-scope="scope">
            <span>{{scope.row.created_at || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="desc"
                         label="备注">
          <template slot-scope="scope">
            <span>{{scope.row.desc || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="last_login"
                         label="最近登录">
          <template slot-scope="scope">
            <span>{{scope.row.last_login === '0000-00-00 00:00:00' ? '-' : scope.row.last_login}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="$router.push({name: '编辑后台用户', params: {userId: scope.row.id}})">
              修改
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="onDelete(scope.row.id)">删除
            </el-button>
            <el-button type="text"
                       size="mini"
                       @click="onCopy(scope.row.id)">复制
            </el-button>
            <div>
              <el-button v-if="maps.type[scope.row.usertype] && scope.row.usertype !== 1"
                         type="text"
                         size="mini"
                         @click="$router.push({path: `/platform-user/ui-permissions/${scope.row.id}`})">
                UI权限
              </el-button>
              <router-link :to="'/platform-user-province/update/'+scope.row.id">
                <el-button type="text"
                           size="mini">分配用户资源
                </el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'


export default {
  mixins: [table],



  data () {
    return {
      search: {
        name: '',
        department_id: '',
        status: '',
        roles: [],
        usertype: [],
        desc: '',
      },
      options: {
        departments: [],
        status: [],
        roles: [],
      },
      maps: {
        department: {},
        type: {},
        status: {},
      },
      searchFieldType: {
        roles: Array,
      },
      platformlist: []
    }
  },



  created () {
    let items = [
      request('getAllDepartments'),
      request('getAdminOptions'),
    ]
    request.all.page(items).then(axios.spread((departments, adminOptions) => {
      this.getAllRoles()
      ;(({data}) => {
        for (let item of data.data) {
          this.maps.department[item.id] = item.name
        }
        this.options.departments = data.data
      })(departments)
      ;(({data}) => {
        this.maps.type = data.type
        this.maps.status = data.status

        for (let k in data.status) {
          this.options.status.push({
            id: k,
            name: data.status[k],
          })
        }
      })(adminOptions)
    }))

    this.fetchPlatformlist()
  },



  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'deletePlatformUser']),


    getAllRoles (currentPage = 1, perPage = 100) {
      request.page('getRolesIndex', {
        current_page: currentPage,
        per_page: perPage,
      }).then(({data}) => {
        this.options.roles = [...this.options.roles, ...data.data]

        if (currentPage < data.total / perPage) {
          this.getAllRoles(++currentPage)
        }
      })
    },


    getTableData (params) {
      // 列表查询默认排除兼职管理员
      params['usertype_not'] = [4]
      return request.page('getPlatformUsersIndex', params)
    },


    onDelete (id) {
      this.$confirm('确认删除此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('deletePlatformUser', id).then((res) => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    onCopy (id) {
      this.$confirm('确认复制此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('copyPlatformUser', id).then((res) => {
          this.$message({
            showClose: true,
            message: '复制成功',
            type: 'success',
          })
          this.onSearch()
        })
      })
    },
    fetchPlatformlist () {
      this.platformlist = []
      return request.common('getPermissionPlatformlist', {}).then(({data}) => {
        this.platformlist.push(data.main)
        this.platformlist.push(...data.others)
        this.platformlist.push({
          name: 'UI权限',
          host: null
        })
      })
    },
  },
}
</script>


<style lang="scss"
       scoped
       src="../style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/platform-user/pages/PlatformUserTable.vue